<script>
import slugify from 'slugify';
import { mapState } from 'vuex';

export default {
  name: 'MenuItemAnchorLinks',

  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      anchors: [],
    };
  },

  computed: {
    ...mapState('menu', ['sectionsInView']),
  },

  watch: {
    $route() {
      this.setAnchors();
    },
  },

  created() {
    this.setAnchors();
  },

  methods: {
    setAnchors() {
      const { versions } = this.page.fields;
      const { version } = this.$route.params;
      const latestVersion = versions[versions.length - 1];

      let currentVersion;

      if (version) {
        const versionNumber = version.replace('v', '');
        currentVersion =
          versions.find((v) => v.fields.versionNumber === versionNumber) || latestVersion;
      } else {
        currentVersion = latestVersion;
      }

      const anchors = currentVersion.fields.sections.map((section) => ({
        id: this.getSectionId(section.fields.heading),
        ...section,
      }));

      this.anchors = anchors;
    },

    getSectionId(heading) {
      return slugify(heading, { lower: true, strict: true });
    },

    isActive(id) {
      const firstVisibleAnchor = this.anchors.find((anchor) =>
        this.sectionsInView.includes(anchor.id),
      );
      return firstVisibleAnchor && firstVisibleAnchor.id === id;
    },

    scrollToId(id) {
      const element = document.querySelector(`#${id}`);
      element.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<template>
  <ul>
    <li v-for="anchor in anchors" :key="anchor.id">
      <router-link
        :to="{ hash: `#${anchor.id}` }"
        @click="scrollToId(anchor.id)"
        :class="{ active: isActive(anchor.id) }"
      >
        {{ anchor.fields.heading }}
      </router-link>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
ul {
  padding: 0;
  > li {
    // We use margins on the list elements instead of padding
    // in the ul to make the collapsing animation smoother
    &:first-child {
      margin-top: 4px;
    }

    &:last-child {
      margin-bottom: 4px;
    }

    > a {
      @include menu-item-level-2;
      padding-left: $space-40;
    }
  }
}
</style>
